export const SET_FEEDBACK_TAB = 'SET_FEEDBACK_TAB';
export const GET_FEEDBACK_RECORDS = 'GET_FEEDBACK_RECORDS';
export const SET_FEEDBACK_RECORDS = 'SET_FEEDBACK_RECORDS';
export const GET_FEEDBACK_QUESTION_TYPES = 'GET_FEEDBACK_QUESTION_TYPES'; // 问题类型
export const SET_FEEDBACK_QUESTION_TYPES = 'SET_FEEDBACK_QUESTION_TYPES';
export const GET_FEEDBACK_HOT = 'GET_FEEDBACK_HOT';
export const SET_FEEDBACK_HOT = 'SET_FEEDBACK_HOT';
export const DELETE_FEEDBACK_HOT = 'DELETE_FEEDBACK_HOT';
export const SET_FEEDBACK_TASK = 'SET_FEEDBACK_TASK';
export const FEEDBACK_QUESTION = [
  {
    name: 'downloadQuestion',
    text: '下载问题',
    child: [
      {
        name: 'sync',
        text: '软件商店可以同时下载几个软件？',
        desc: '目前软件商店没有任务数量限制，暂时也无法设置任务数量。',
      },
      {
        name: 'cancel',
        text: '如何取消下载中的任务？',
        desc: '您可以点击软件商店右上角“下载任务管理器”可以取消正在下载中的任务。',
      },
      {
        name: 'package',
        text: '下载的软件安装包存放在哪里？',
        desc:
          '请您点击软件商店右上角“菜单栏”进入“设置中心”查看下载路径，点击“打开”可以直接打开安装包存放文件夹。',
      },
      {
        name: 'path',
        text: '下载路径是否可以修改？',
        desc:
          '下载路径可以修改。请通过“设置中心”进行修改。待修改完毕后点击确定进行保存。\n备注：路径设置中不可包含特殊符号',
      },
      {
        name: 'delete',
        text: '下载完成后是否可以自动删除安装包？',
        desc:
          '您可以通过 "设置中心" 开启安装包清理功能，开启该功能后安装包会在下载完成7天后进行删除，无需您手动清理。',
      },
      {
        name: 'fail',
        text: '下载中出现“下载失败”或下载进度为0，如何解决？',
        desc:
          '请您先尝试将“设置中心”中的下载路径进行修改试试，另建议您更换网络环境再尝试一下；除此之外，您还可以试试重置网络，重置网络步骤可参考此贴：<strong><a href="https://jingyan.baidu.com/article/4f34706e007ba3e386b56d4b.html" style="color:#333" target="_blank">点击查看</a></strong>。如完成上述操作依然无法下载，请通过“我要反馈”提交问题，我们会进一步核实处理。',
      },
      {
        name: 'delay',
        text: '下载速度很慢，如何解决？',
        desc:
          '软件商店下载速度取决于您的本地网络和我们服务器的连接状态有关，建议您可以重启路由器或更换网络尝试一下。',
      },
    ],
  },
  {
    name: 'download',
    text: '安装问题',
    child: [
      {
        name: 'path',
        text: '软件商店如何设置软件安装路径？',
        desc:
          '普通软件当前不支持设置安装路径，您可以在该软件安装器界面通过“自定义安装”或“高级设置”来选择安装路径。',
      },
      {
        name: 'feature',
        text: '快装功能介绍',
        desc:
          '部分软件支持快装功能（即静默安装），您可以通过右上角菜单进入“设置中心”开启快装功能并设置快装软件的安装路径。支持快装功能软件会在安装按钮处显示为“快装”。',
      },
      {
        name: 'file',
        text: '快装软件未安装到设置快装路径的文件夹内',
        desc: '如您遇到上述情况，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'downloading',
        text: '任务管理器一直显示“安装中”',
        desc:
          '部分免安装软件（下载完即运行），下载完成后会一直显示安装中状态，该情况不影响您的正常使用。例如：geekuninstaller。',
      },
      {
        name: 'fail',
        text: '安装界面显示安装失败',
        desc:
          '如您出现安装失败问题，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
    ],
  },
  {
    name: 'update',
    text: '升级问题',
    child: [
      {
        name: 'how',
        text: '如何升级软件？',
        desc:
          '您可点击软件商店左侧导航“软件升级”，如存在可升级软件会显示在右侧列表中，您可以点击全部升级或单个软件升级。',
      },
      {
        name: 'ignore',
        text: '如何忽略升级软件？',
        desc:
          '在可升级软件列表中将鼠标移至软件所在位置会出现“忽略”按钮，点击后即可忽略此次版本升级。忽略后将不再出现在升级列表中，待下次软件有新版本后才会显示。',
      },
      {
        name: 'showagin',
        text: '已忽略的升级软件如何再次显示出来？',
        desc:
          '目前已忽略的软件无法再次显示，需等待该软件再次升级时才能出现。如需显示，目录：C:\\ProgramData\\Lenovo\\devicecenter\\LStoreSoftsCache下的文件删除，重启软件商店。',
      },
      {
        name: 'number',
        text: '桌面商店图标显示的升级软件数字与软件商店中可升级软件数字不符？',
        desc:
          '如您此类情况或桌面有显示数字而软件商店中没有可升级软件。请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'errorUpdate',
        text: '升级成功完成后，依然提示升级该软件',
        desc:
          '该问题可能是由于升级后注册表信息未更新导致的，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'nothave',
        text: '本地并未安装此软件，但升级列表中出现此软件升级提示',
        desc:
          '该问题可能是由于软件信息错误导致的升级提示，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
    ],
  },
  {
    name: 'uninstall',
    text: '卸载问题',
    child: [
      {
        name: 'modal',
        text: '卸载软件时提示“找不到xxxxx文件，请确定文件名是否正确后，再试一次”',
        desc:
          '出现该情况有可能是您该文件路径下卸载文件已经被删除了所导致的，建议您下载安装“geekuninstaller”工具进行强力删除尝试。',
      },
      {
        name: 'residual',
        text: '为什么我已经删除的软件还会出现在“我的软件”列表中？',
        desc:
          '该情况可能是您删除了文件夹但并未清理软件注册表信息所导致的。建议您下载安装“geekuninstaller”工具，然后进行注册表信息清理操作尝试。',
      },
      {
        name: 'other',
        text: '为什么运行了卸载程序依然无法卸载软件？',
        desc:
          '如果您运行了卸载程序依然无法卸载掉该软件，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
    ],
  },
  {
    name: 'running',
    text: '运行问题',
    child: [
      {
        name: 'icon',
        text: '点击桌面软件商店快捷方式图标，点击后没有任何反应',
        desc:
          '如出现上述情况，请您右键查看软件商店图标的属性，查看“目标”内是否空白，如果是空白请您删除桌面快捷方式。然后通过联想电脑管家进入软件商店，再退出时重新创建快捷方式。',
      },
      {
        name: 'load',
        text: '打开软件商店后无法加载内容，页面为空白的',
        desc:
          '请您打开查看隐藏文件夹功能将C:\\ProgramData\\Lenovodevicecenter\\LStoreSoftsCache 这个文件夹进行删除，然后重新打开软件商店尝试。如果依然无法正常加载内容，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'running_dealy',
        text: '页面加载速度慢',
        desc:
          '如软件商店中页面加载速度很慢，建议您重启路由或更换网络尝试。如依然很慢，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'no_network',
        text: '打开商店显示无法连接网络，如何解决？',
        desc:
          '请您参照以下步骤试试，在控制面板网络和internet设置中选择“internet选项”——“高级”，在“安全”选项中，取消勾选ssl2.0和SSl3.0，勾选TLS1.0，TLS1.1，TLS1.2；保存设置后，重启商店。如完成上述操作依然无法连接网络，请通过“我要反馈”提交反馈，我们会进一步核实处理。',
      },
    ],
  },
  {
    name: 'buy',
    text: '商品购买',
    child: [
      {
        name: 'buy_question',
        text: '您在商品购买中或购买后有问题需要咨询？',
        desc: '商品购买问题请联系商城客服QQ：3152497638。我们会尽快回复您，帮助解决该问题。',
      },
    ],
  },
  {
    name: 'wallpaper',
    text: '壁纸问题',
    child: [
      {
        name: 'downloadwp',
        text: '壁纸是否可以下载？',
        desc: '抱歉，目前软件商店中的壁纸是不支持下载，请您谅解。',
      },
      {
        name: 'screen',
        text: '壁纸是否可以设置为锁屏？',
        desc:
          '抱歉，目前壁纸无法设置为壁纸，建议您可以搜索联想锁屏软件哦，联想锁屏也提供很多精美的锁屏，您可以体验一下。',
      },
      {
        name: 'collect',
        text: '如何查看曾经设置过的壁纸或收藏的壁纸？',
        desc: '您可以进入“壁纸”内“我的壁纸”查看已收藏或设置过的壁纸。',
      },
      {
        name: 'cancel',
        text: '如何取消已设置过的壁纸？',
        desc: '您好，您可以在桌面点击鼠标右键进入“个性化”中切换回系统自带壁纸哦。',
      },
    ],
  },
  {
    name: 'apk',
    text: '联想模拟器',
    child: [
      {
        name: 'what',
        text: '为什么要使用联想模拟器？模拟器有什么作用？',
        desc:
          '部分手机中的应用是无法在windows系统中直接运行的，需要模拟器为其提供android运行环境。例如：抖音、学习通等。',
      },
      {
        name: 'start',
        text: '联想模拟器在启动时进度条卡住，无法正常启动。',
        desc:
          '模拟器在启动时如卡住进度，请关闭或者卸载360一类的软件。然后退出模拟器之后再开，若仍然打不开请在控制面板 - 卸载程序中卸载模拟器，然后通过商店重新安装模拟器',
      },
      {
        name: 'error',
        text: '联想模拟器画面出现卡顿、掉帧、花屏的情况。',
        desc:
          '如出现上述情况，请您进入右上角模拟器中“系统设置”。将“引擎”中的性能设置调整到更高同时切换渲染模式进行尝试。如依然无法解决，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'screen',
        text: '为什么联想模拟器看抖音只有声音，而视频是黑屏的？',
        desc:
          '请您在模拟器中将设置内的渲染模式进行下切换再次尝试。如果依然不行，建议您重新安装模拟器尝试一下。',
      },
      {
        name: 'voice',
        text: '联想模拟器没有声音',
        desc:
          '如出现上述情况，请您进入右上角模拟器中“系统设置”。查看“设备”中声音播放设置是否正确。如依然没有音频输出，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'network',
        text: '联想模拟器无法联网',
        desc:
          '请您打开模拟器中浏览器输入百度的网址尝试是否可以打开。如果正常开启说明模拟器联网正常；如无法开启，请您尝试关闭模拟器中的wifi链接，并断开电脑的网络链接。重新连接电脑网络和模拟器中wifi再尝试。如依然无法解决，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'package',
        text: '联想模拟器如何安装外部的apk包？',
        desc: '您可以开启联想模拟器，然后将APK安装包直接拖入模拟器中进行安装。',
      },
      {
        name: 'export',
        text: '如何导出模拟器中的文件或导入电脑中文件？',
        desc:
          '您可以在联想模拟器右侧菜单栏中点击“更多”点击“共享”进入共享文件夹。点击安卓机器人图标进入模拟器中共享文件夹，将模拟器中需要导出的文件放入此文件夹，点击windows图标可以打开电脑中共享文件夹将文件取出即可。反之即可导入电脑中文件进模拟器。',
      },
      {
        name: 'running',
        text: '联想模拟器中应用出现停止运行情况',
        desc:
          '请您退出联想模拟器重新打开再次尝试应用是否可以正常运行。如果依然无法正常运行，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
    ],
  },

  {
    name: 'other',
    text: '其他问题',
    child: [
      {
        name: 'history',
        text: '是否可以查看历史安装软件记录或卸载软件记录？',
        desc: '抱歉，暂时不支持查看历史安装记录或卸载记录。',
      },
      {
        name: 'bingdu',
        text: '下载安装第三方软件出现报病毒的情况',
        desc:
          '软件商店上架的软件均是经过人工审核的，并且通过各大主流杀毒软件检测通过的。如您遇到上述问题，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'comment',
        text: '评论被禁言',
        desc:
          '抱歉，如果您发布的评论内容中包含敏感字符是可能会被禁言的。如果您对禁言表示异议，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'publish',
        text: '如何发布软件评论？',
        desc: '首先您需要在软件商店左下角登录您的账号，登录后软件详情页面即可评论。',
      },
      {
        name: 'create',
        text: '如何创建桌面快捷方式打开软件商店？',
        desc:
          '在您退出软件商店时候我们会提示您创建桌面快捷方式。如果您无意关闭了此提示并且选择近期不再提醒，可以进入文件夹：C:\\Program Files (x86)\\LenovoPCManager找到LenovoAppStore.exe文件，右键创建快捷方式或发送到桌面快捷方式即可',
      },
    ],
  },
];
